import { createApi } from '@reduxjs/toolkit/query/react';

import { INTERNAL_ERROR_STATUS_CODE } from '@/constants';
import { getBreadcrumbsApiRequestUrl, request } from '@/utils';

export const breadcrumbsApi = createApi({
  reducerPath: 'breadcrumbs',
  endpoints: (builder) => ({
    getBreadcrumbs: builder.query({
      queryFn: async ({ pathname, locale }) => {
        try {
          const url = getBreadcrumbsApiRequestUrl({ pathname, locale });
          const response = await request(url);

          return {
            data: response?.data,
          };
        } catch (error) {
          return {
            error: {
              status: error?.response?.status || INTERNAL_ERROR_STATUS_CODE,
            },
          };
        }
      },
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetBreadcrumbsQuery,
  util: { getRunningQueriesThunk: getRunningOperationPromisesBreadcrumbs },
} = breadcrumbsApi;

// export endpoints for use in SSR
export const { getBreadcrumbs } = breadcrumbsApi.endpoints;
